/**
 * Pins the page where it is, so window.scrollY reads 0 while nothing visibly
 * moves. vue3-color-gradient-picker mixes e.pageY with getBoundingClientRect(),
 * so any scroll offset shifts every click on the picker by that amount.
 *
 * Leaves `overflow` alone: vue-final-modal saves and restores it itself.
 */
export function lockPageScroll() {
  const { style } = document.body;
  if (style.position === "fixed") return false;

  const scrollTop =
    window.pageYOffset || document.documentElement.scrollTop || 0;
  style.position = "fixed";
  style.top = `-${scrollTop}px`;
  style.left = "0";
  style.right = "0";
  style.width = "100%";
  return true;
}

export function unlockPageScroll() {
  const { style } = document.body;
  const scrollTop = Math.abs(parseInt(style.top, 10)) || 0;
  style.position = "";
  style.top = "";
  style.left = "";
  style.right = "";
  style.width = "";
  window.scrollTo(0, scrollTop);
}
